export const trendClass = (trend) => {
  if (trend === "increased") return "kbv-odds-value--up";
  if (trend === "decreased") return "kbv-odds-value--down";
  return "";
};

export const hasTrend = (trend) => trend === "increased" || trend === "decreased";
